/**
 * Aroon Indicator
 *
 * Identifies trend direction and strength by measuring time since the
 * highest high (Aroon Up) and lowest low (Aroon Down) over `period` bars.
 * Values range 0–100; crossover signals trend changes.
 *
 * Category: Trend | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const aroonIndicator: IndicatorDefinition = {
  id: "aroon",
  name: "Aroon",
  shortName: "AROON",
  category: "trend",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 25, min: 1, max: 200 },
  ],
  plots: [
    { key: "aroonUp", label: "Aroon Up", color: "#4CAF50", style: "line", lineWidth: 2, priceScaleId: "aroon" },
    { key: "aroonDown", label: "Aroon Down", color: "#F44336", style: "line", lineWidth: 2, priceScaleId: "aroon" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period } = params;
    const upData: { time: number; value: number }[] = [];
    const downData: { time: number; value: number }[] = [];

    for (let i = period; i < candles.length; i++) {
      let highIdx = 0;
      let lowIdx = 0;
      let highVal = -Infinity;
      let lowVal = Infinity;

      for (let j = 0; j <= period; j++) {
        const idx = i - period + j;
        if (candles[idx].high > highVal) { highVal = candles[idx].high; highIdx = j; }
        if (candles[idx].low < lowVal) { lowVal = candles[idx].low; lowIdx = j; }
      }

      upData.push({ time: candles[i].time, value: (highIdx / period) * 100 });
      downData.push({ time: candles[i].time, value: (lowIdx / period) * 100 });
    }

    return [
      { key: "aroonUp", data: upData },
      { key: "aroonDown", data: downData },
    ];
  },
};
